const MINOR_WORDS = new Set([
  "a",
  "an",
  "and",
  "at",
  "by",
  "for",
  "from",
  "in",
  "of",
  "on",
  "or",
  "the",
  "to",
  "with",
]);

// Nav labels are authored in mixed cases; a second capital means an acronym to leave alone.
export function titleCase(label: string): string {
  if (label.trimEnd().endsWith("?")) return label;
  return label
    .split(" ")
    .map((word, i) => {
      if (/[A-Z]/.test(word.slice(1))) return word;
      const lower = word.toLowerCase();
      if (i > 0 && MINOR_WORDS.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}
